"use client";

import { MainData } from "@/components/common/CommonArray/FileArray";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import styles from "./RelatedTools.module.css";
// import posthog from "posthog-js";

const RELATED_LIMIT = 6;

interface RelatedToolsProps {
  currentNavigate: string;
  maintype: string;
}

export default function RelatedTools({
  currentNavigate,
  maintype,
}: RelatedToolsProps) {
  const t = useTranslations("toolPara");

  const related = MainData.filter(
    (item) =>
      item.maintype === maintype && item.navigate !== currentNavigate
  ).slice(0, RELATED_LIMIT);

  if (related.length === 0) return null;

  return (
    <section className={`container-md ${styles.section}`}>
      <div className={styles.box}>
        <h2 className={styles.heading}>{t("relatedTools")}</h2>
        <p className={styles.intro}>{t("youMightAlsoFind")}</p>
        <ul className={styles.list}>
          {related.map((item) => (
            <li key={item.navigate}>
              <Link
                href={item.navigate}
                className={`hover:opacity-90 ${styles.link}`}
                // onClick={() =>
                //   posthog.capture('related_tool_clicked', {
                //     tool_name: item.Name,
                //     tool_href: item.navigate,
                //     source_tool: currentNavigate,
                //     tool_category: maintype,
                //   })
                // }
              >
                {item.Name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
